function ChurnedAccountIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.337 13L6.965 8.44 3.627 13H1l4.615-6.12L1.25 1h2.609l3.177 4.269L10.178 1h2.502L8.332 6.794 13 13h-2.663zM28.337 13l-3.372-4.56L21.627 13H19l4.615-6.12L19.25 1h2.609l3.177 4.269L28.177 1h2.503l-4.349 5.794L31 13h-2.663zM46.337 13l-3.373-4.56L39.627 13H37l4.615-6.12L37.248 1h2.61l3.178 4.269L46.178 1h2.503l-4.35 5.794L49 13h-2.663z"
        fill="#97999B"
      />
    </svg>
  )
}

export default ChurnedAccountIcon
